import { ChevronLeft, ChevronRight } from "lucide-react";

export default function LeadPagination({
    pagination,
    search,
    onPageChange,
    onLimitChange,
}) {
    const perPage = pagination.perPage || 100;
    const currentPage = pagination.currentPage || 1;
    const lastPage = pagination.lastPage || 1;
    const total = pagination.total || 0;
    const start = total === 0 ? 0 : (currentPage - 1) * perPage + 1;
    const end = Math.min(currentPage * perPage, total);

    return (
        <div className="flex min-h-9 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-[13px] font-medium text-[#6d8493]">
                {total === 0 ? "No leads to show" : (
                    <>
                        Showing <span className="font-bold text-[#405c6d]">{start}–{end}</span> of{" "}
                        <span className="font-bold text-[#405c6d]">{total}</span> leads
                    </>
                )}
            </p>

            <div className="flex flex-wrap items-center gap-2">
                <label className="flex items-center gap-2 text-[13px] font-medium text-[#6d8493]">
                    Rows
                    <select
                        aria-label="Rows per page"
                        value={perPage}
                        onChange={(event) => onLimitChange?.(Number(event.target.value))}
                        className="h-9 rounded-xl border border-[#d6e5eb] bg-white px-2.5 text-[13px] font-semibold text-[#405c6d] outline-none transition hover:border-[#a9cad9] focus:border-[#50b8e7] focus:ring-2 focus:ring-[#dff2f9]"
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </label>

                <span className="mx-1 h-4 w-px bg-[#d6e5eb]" />

                <button
                    type="button"
                    aria-label="Previous page"
                    disabled={currentPage <= 1}
                    onClick={() => onPageChange?.(currentPage - 1, search)}
                    className="flex h-9 w-9 items-center justify-center rounded-xl border border-[#d6e5eb] bg-white text-[#647d8e] transition hover:border-[#a9cad9] hover:bg-[#f1f8fb] hover:text-[#236fa3] disabled:cursor-not-allowed disabled:opacity-35"
                >
                    <ChevronLeft className="h-4 w-4" />
                </button>

                <span className="min-w-[72px] text-center text-[13px] font-semibold text-[#526e7e]">
                    {currentPage} of {lastPage}
                </span>

                <button
                    type="button"
                    aria-label="Next page"
                    disabled={currentPage >= lastPage}
                    onClick={() => onPageChange?.(currentPage + 1, search)}
                    className="flex h-9 w-9 items-center justify-center rounded-xl border border-[#d6e5eb] bg-white text-[#647d8e] transition hover:border-[#a9cad9] hover:bg-[#f1f8fb] hover:text-[#236fa3] disabled:cursor-not-allowed disabled:opacity-35"
                >
                    <ChevronRight className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
